export const housingFormTabs = {
  overview: 'overview',
  thread: 'thread',
  initiatives: 'initiatives',
  plots: 'plots',
  popularHousingForms: 'popularHousingForms',
} as const

export const housingFormTabsQueryParamName = 'tab'
